import { render, staticRenderFns } from "./FeatureDialog.vue?vue&type=template&id=bd2bdb4e&scoped=true"
import script from "./FeatureDialog.vue?vue&type=script&lang=js"
export * from "./FeatureDialog.vue?vue&type=script&lang=js"
import style0 from "./FeatureDialog.vue?vue&type=style&index=0&id=bd2bdb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2bdb4e",
  null
  
)

export default component.exports